import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UploadDataSourceDocument } from './upload.generated';

export const useUploadDataSource = (options: ApiOptions<typeof UploadDataSourceDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UploadDataSourceDocument, {
    ...useNotifications(UploadDataSourceDocument, {
      failure: (error) => {
        if (error.message === 'Malformed file') {
          const kind = error.graphQLErrors[0].extensions.csv ? 'CSV' : 'XLSX';
          return kind === 'CSV'
            ? t('api.data_sources.upload_error_malformed_csv')
            : t('api.data_sources.upload_error_malformed_xlsx');
        }
        if (error.message.includes('Foreign id name not in keys')) {
          return t('api.data_sources.upload_error_unique_id_mismatch');
        }
        if (error.message.includes('Duplicate or missing foreign ids'))
          return t('api.data_sources.upload_error_duplicate_ids');
        return t('api.common.error_generic');
      },
      success: t('api.data_sources.upload_success'),
    }),
    ...options,
  });
};
